<template>
  <v-row justify="center" no-gutters>
    <v-col cols="auto">
      <v-card elevation="0" color="transparent">
        <v-card-title class="pt-2 pb-0">
          <v-form v-model="Validity" ref="ConfigForm">
            <v-row justify="center" no-gutters>
              <v-col cols="12" xl="2" lg="2">
                <v-card class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2" elevation="0">
                  <v-autocomplete
                      prepend-inner-icon="mdi-map-marker-outline"
                      hide-details
                      placeholder="Select Park"
                      :items="ParksList"
                      required
                      :rules="[v => !!v || 'Park is required']"
                      item-text="name"
                      item-value="id"
                      v-model="SelectedPark"
                      outlined>
                  </v-autocomplete>
                </v-card>
              </v-col>

              <v-col cols="12" xl="2" lg="2" md="2">
                <v-dialog
                    ref="dialog"
                    v-model="DayDialogIn"
                    :return-value.sync="CheckInDate"
                    persistent
                    width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-card class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2" elevation="0">
                      <v-text-field
                          hide-details
                          v-model="CheckInDate"
                          outlined
                          placeholder="Check In Date"
                          prepend-inner-icon="mdi-calendar-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </v-card>
                  </template>
                  <v-date-picker
                      v-model="CheckInDate"
                      scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="DayDialogIn = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(CheckInDate)">
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" xl="2" lg="2" md="2">
                <v-dialog
                    ref="dialogOut"
                    v-model="DayDialogOut"
                    :return-value.sync="CheckOutDate"
                    persistent
                    width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-card class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2" elevation="0">
                      <v-text-field
                          hide-details
                          v-model="CheckOutDate"
                          placeholder="Check Out Date"
                          outlined
                          prepend-inner-icon="mdi-calendar-outline"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                      ></v-text-field>
                    </v-card>
                  </template>
                  <v-date-picker
                      v-model="CheckOutDate"
                      scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                        text
                        color="primary"
                        @click="DayDialogOut = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                        text
                        color="primary"
                        @click="$refs.dialogOut.save(CheckOutDate)"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>

              <v-col cols="12" xl="2" lg="2">
                <v-card class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2" elevation="0">
                  <v-select
                      prepend-inner-icon="mdi-account-outline"
                      :items="PeopleList"
                      v-model="SelectedPeople"
                      hide-details
                      :rules="[v => !!v || 'Number of Guests are required']"
                      placeholder="Select No Of Guests"
                      outlined>
                  </v-select></v-card>
              </v-col>


              <v-col class="mb-4" cols="auto" xl="2" lg="2">
                <div class="ml-2 mr-2 ml-sm-0 mr-sm-0 mr-lg-2 ml-lg-2">
                  <v-btn width="100%" class="ma-0" @click="goToPackageSelection" height="56" dark color="#D6AF44">
                    Book Now
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>

        </v-card-title>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
export default {
  name: "ConfigBar",
  data:()=>({
    DayDialog: false,
    Validity: false,
    ParksList: [],
    PeopleList: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],

    SelectedPark: null,
    SelectedPeople: null,
    DayDialogIn: false,
    DayDialogOut: false,
    CheckInDate: null,
    CheckOutDate: null,
  }),
  methods:{
    getParks(){
      axios.get('https://admin.wca.innocube.lk/api/park').then(value => {
        console.log(value.data.data);
        this.ParksList = value.data.data;
      });
    },
    goToPackageSelection(){
      this.$refs.ConfigForm.validate();
      if(this.Validity){
        this.$router.push({
          name: 'Packages',
          params:{
            SelectedPark: this.SelectedPark,
            SelectedPeople: this.SelectedPeople,
            SelectedDay: [
              this.CheckInDate,
              this.CheckOutDate
            ],
          }
        });
      }
    }
  },
  mounted() {
    this.getParks();
  }
}
</script>

<style scoped>

</style>
